var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-toolbar"},[_vm._l((_vm.items),function(item,index){return [(item.type === 'divider')?_c('div',{key:`divider${index}`,staticClass:"divider"}):_c('menu-item',_vm._b({key:index},'menu-item',item,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }